import {setPageConfig,setNowTabPageCongfig,clearRowDataDeep,getMyColums} from "@/tools/table-drag.js";
let cacheSize = parseInt(localStorage.getItem('pageSize'));
import {getRandomString,isNotEmpty} from "@/tools/utils";
const tableData = {};
const pageConfig = {
    resetPage:null,
    loading:false,
    updateErpMaterialLaoding:false,
    tableName:'material-data',
    height:'',
    pageKey:getRandomString(),
    top_tools:{
        "ITEM":[
            // { index: 0, name: ['手动更新物料'], icon: 'fas fa-sync-alt', check_lines: 0, on_click: [], sign: 'updateErpMaterial', },
            { index: 0, name: ['导出'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
            // { index: 1, name: ['手动接收'], icon: 'fas fa-hand-paper', check_lines: 0, on_click: [], sign: 'handleGet', },
        ]
    },
    pageConfig:{},
    pageConfigTree:[],
}
const state = () => ({
    materialData: Object.assign({}, tableData,pageConfig),
})
const getters = {
    getPageConfig: state => state.materialData.pageConfig,
    getPageConfigTree: state => state.materialData.pageConfigTree,
    getPageKey:state => state.materialData.pageKey,
}
const mutations ={
    setRestPageFun(state, data){
        state.materialData.resetPage = data;
    },
    setLoading(state, data){
        state.materialData.loading = data;
        if(isNotEmpty(state.materialData.pageConfig)){
            Object.keys(state.materialData.pageConfig).forEach((key,index)=>{
                state.materialData.pageConfig[key].loading = data;
            })
        }
    },
    setPageConfig(state, data){
        state.materialData.pageConfig = data.pageConfig;
        state.materialData.pageConfigTree = data.allArrData;
        state.materialData.pageKey = getRandomString();
        if(isNotEmpty(state.materialData.pageConfig)){
            Object.keys(state.materialData.pageConfig).forEach((key,index)=>{
                state.materialData.pageConfig[key].height = state.materialData.height
            })
        }
    },
    setList(state, data) {
        state.materialData.pageConfig[data.obj].data = data.data;
        state.materialData.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    ['refreshTableHeight'](state, data) {
        state.materialData.height = (data+10) + 'px';
        if(isNotEmpty(state.materialData.pageConfig)){
           Object.keys(state.materialData.pageConfig).forEach((key,index)=>{
               state.materialData.pageConfig[key].height = state.materialData.height;
           })
        }
    },
    ['clearData'](state, data) {
        clearRowDataDeep({tabName:data.tabName,pageConfig:state.materialData.pageConfig,pageConfigTree:state.materialData.pageConfigTree});
    }
}
const actions = {
    async ['fetch-list']({ state, dispatch, rootState ,commit}, payload) {
        if(state.materialData.loading) return;
        commit('setLoading',true);
        let msg = { command: "get_client__material_list", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return_list']({ state, commit }, payload) {
        commit('setLoading',false);
        if (payload.success) {
            if(!isNotEmpty(state.materialData.pageConfigTree)){//生成 页面列配置 并处理成需要的结构
                let pageData = setPageConfig({pageData:payload.data.objs,tableName:state.materialData.tableName,top_tools:state.materialData.top_tools});
                commit('setPageConfig',pageData);
            }
            let myCoums = await getMyColums({name:state.materialData.tableName+'-'+payload.data.obj});//获取偏好
            setNowTabPageCongfig({pageConfig:state.materialData.pageConfig[payload.data.obj],myColums:myCoums})//设置为自己的偏好
            commit('setList',payload.data);
        }
    },
    ['return_export']({ state, commit }, payload) {
        if(payload.success){
            window.open(process.env.VUE_APP_APIHOST+'/'+payload.data);
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        let msg = { command: "get_client__material_export_excel", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_inventory__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
